import { Divider } from "@mantine/core";
import { Link } from "react-router-dom";
import { ReferenceApi } from "../../../apis";
import { PageLayout } from "../../../components/layout";
import { ColumnType, Table } from "../../../components/table";
import { Tag } from "../../../components/tags";
import RenderText from "../../../components/ui/render-text";
import { IReference } from "../../../interfaces/IReference";
import { dateTimeFormat } from "../../../utils/date";

export function ReferenceB2bList() {
  const breadcrumbs = useBreadcrumb();
  const columns = useHeader();

  return (
    <PageLayout title="Төлбөрийн нөхцөл" subTitle="Төлбөрийн нөхцөлийн мэдээллийн жагсаалт" breadcrumb={breadcrumbs}>
      <Divider color="#e5e5e5" my="md" />
      <Table name="reference-b2b.list" columns={columns} filters={{ query: "" }} loadData={(data) => ReferenceApi.list(data!)} />
    </PageLayout>
  );
}

const useHeader = (): ColumnType<IReference>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => <RenderText text={record?.name || "-"} />,
  },
  {
    title: "Код",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => <Tag color="blue.5" name={record?.refCode || ""} />,
  },
  {
    title: "Төрөл",
    sorter: true,
    dataIndex: "listType",
    render: (record) => {
      if (record?.listType === "REGION" || record?.listType === "DIRECTION") {
        return <Tag name={record?.name || "-"} color="blue.5" />;
      } else {
        return (
          <Link to={`/reference/b2b-list/payment-term/${record?.listType}`}>
            <Tag name={record?.name || "-"} color="blue.5" variant="light" useHover />
          </Link>
        );
      }
    },
  },
  {
    title: "Тайлбар",
    sorter: true,
    dataIndex: "description",
    render: (record) => <RenderText text={record?.description || "-"} />,
  },
  {
    title: "Бүртгэсэн огноо",
    sorter: true,
    dataIndex: "createdAt",
    render: (record) => <RenderText text={dateTimeFormat(record?.createdAt)} />,
  },
];

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Эхлэл",
  },
  {
    label: "Лавлах мэдээлэл",
  },
];
